import { hasPagePermissions } from 'hooks/hasPagePermissions'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ButtonGroup } from 'stories/components'

import { BorrowerPipelineConfiguration } from '../BorrowerPipelineConfiguration'

const tabs = {
  borrower: 'Borrower Application',
  broker: 'Broker Application',
}

export const CustomizeApplication = ({ setChanged }: { setChanged: (changed: boolean) => void }) => {
  const location = useLocation()
  const navigate = useHistory()
  const borrowerAllowed = hasPagePermissions(['admin_tool', 'borrowerPipeline'])
  const brokerAllowed = hasPagePermissions(['admin_tool', 'brokerPipeline'])

  const tabFromSearch = () => {
    const requested = new URLSearchParams(location.search).get('tab')
    if (requested === 'broker' && brokerAllowed) return 'broker'
    if (requested === 'borrower' && borrowerAllowed) return 'borrower'
    return borrowerAllowed ? 'borrower' : 'broker'
  }

  const [tab, setTab] = useState(tabFromSearch)

  useEffect(() => {
    setTab(tabFromSearch())
  }, [location.search])

  const visible: Record<string, string> = {}
  if (borrowerAllowed) visible.borrower = tabs.borrower
  if (brokerAllowed) visible.broker = tabs.broker

  const onChange = (next: string) => {
    setTab(next)
    navigate.replace(`/admin_tool/customizeApplication?tab=${next}`)
  }

  return (
    <div>
      <h1 className="text-2xl font-bold flex items-center pb-4">Customize Application</h1>
      <ButtonGroup title={visible} value={tab} onChange={onChange} />
      <div className="mt-4">
        <BorrowerPipelineConfiguration key={tab} type={tab === 'broker' ? 'broker' : 'borrower'} setChanged={setChanged} />
      </div>
    </div>
  )
}
